import { useMemo } from "react";
import { buildPrimitives } from "@/lib/geometry";
import { Primitives } from "@/components/Primitives";

export const ElevationThumb = ({ item, size = 64, palette = "dark", dims = false, labels = false, className = "" }) => {
  const { prims, bounds } = useMemo(() => buildPrimitives(item, { dims, labels }), [item, dims, labels]);
  const u = Math.max(bounds.w, bounds.h) / size;
  return (
    <svg viewBox={`${bounds.x} ${bounds.y} ${bounds.w} ${bounds.h}`} className={className}
      style={{ width: "100%", height: "100%" }} preserveAspectRatio="xMidYMid meet">
      <Primitives prims={prims} u={u} palette={palette} />
    </svg>
  );
};
